<template>
    <div class="outer" :style="componentStyles">
        <div class="ripple ripple--no-animation"></div>
        <!-- <div class="ripple five"></div> -->
        <div 
            class="ripple four"
            :style="getAnimationStyle(.75)"
        />
        <div 
            class="ripple three"
            :style="getAnimationStyle(.5)"
        />
        <div 
            class="ripple two"
            :style="getAnimationStyle(.25)"
        />
        <div 
            class="ripple one" 
            :style="getAnimationStyle(0)"
        />
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'APMapHerePoint',
    computed: {
        ...mapGetters([
            'getMapConfigProp',
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.APMapHerePoint.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.APMapHerePoint.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.APMapHerePoint.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.APMapHerePoint.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        animationSpeed() {
            return +this.componentStyles['--a-p-map-here-point__animation-speed']
        }
    },
    methods: {
        getAnimationStyle(order) {
            return {
                animation: `ripple ${this.animationSpeed ? this.animationSpeed : 0 }s infinite`,
                animationDelay: `-${+this.animationSpeed && order? this.animationSpeed*order : 0}s`
            }
        }
    }
};
</script>

<style lang="scss" src="./theme.scss" />
